export function modelFunc () {
    let currentDate = new Date();
    let validityDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    
    let model = {
        buttonDisabled: false,

        //Send PDF Form
        countKB: '0 KB',
        fileError: '',
        fileName: '',
        fileType: [],
        mailSubject: 'Dateien aus dem wesernetz Medienportal',
        receiver: '',
        sender: '',
        senderName: '',
        textMessage: '',
        textMessagePlain: '',
        signatureText: '',

        //change user data
        name: '',
        email: '',
        company: '',
        signature: '',
        signatureSelect: 0,
        userStatus: sessionStorage.getItem('wnPortal_status'),

        //new Document
        automaticRelease: false,
        files: [],
        filesUpload: [],
        fileTypeGeneral: ['web', 'edit', 'print', 'ovn', 'xlsx', 'pptx', 'docx', 'zip'],
        jpgCount: 0,
        newFile: false,
        docActive: true,
        docAdvisor: 0,
        docAdvisorName: '',
        docAgency: 1,
        docArea: 0,
        docCategory: 0,
        docCurrentTitle: '',
        docDateRelease: currentDate,
        docDateValidity: validityDate,
        docFileName: '',
        docFolderName: '',
        docInventarNumber: 0,
        docMediaType: 0,
        docNetLocation: 0,
        docNotations: '',
        docPurpose: '',
        docPreVersion: false,
        docPreVersionFile: [],
        docSection: [],
        docServiceProvider: false,
        docServiceProviderId: [],
        docTitleSafe: '',
        docTopic: '',
        docVersionNumber: 0,
        emailReceiver: [],
        emailReceiverFurther: '',
        emailSend: true,
        printAgency: 0,
        printColor: 0,
        printComment: '',
        printFormat: 0,
        printPages: '',
        printPageType: 0,
        printProduction: 0,
        //explicit print values
        printProductionExplicit: '',
        printType: 0,
        showPrintValues: 0,
        wnWebsite: false,
        wnWebsiteId: 0,
        wnWebsiteTitle: '',
        wnWebsiteType: '',
        wnWebsiteUpdate: false,
        //fileType
        fileCurrent: [],
        web: 0,
        fileWeb: [],
        print: 0,
        filePrint: [],
        edit: 0,
        fileEdit: [],
        ovn: 0,
        fileOvn: [],
        pptx: 0,
        filePptx: [],
        xlsx: 0,
        fileXlsx: [],
        docx: 0,
        fileDocx: [],
        zip: 0,
        fileZip: [],

        //parameter
        paramType: '',
        paramStatus: '',
        paramName: '',
        paramMail: '',
        paramStreet: '',
        paramPlz: '',
        paramCity: '',
        paramPhone: '',
        paramPaperType : '',
        paramWeightCover : '',
        paramWeightContent : '',
        paramWeightGeneral : '',
        paramOtherPaper : false,
        paramPaperProduction : '',
        paramComments : '',
        paramComments2 : '',

        //send to printery
        requestSelect: 0,
        requestDocId: 0,
        requestAdvisorId: 0,
        requestAdvisorName: '',
        requestAdvisorMail: '',
        requestMailreceiver: '',
        requestMessage: '',
        requestFile: '',
        requestDocTitle: '',

        //order
        orderCostCenter: '',
        orderAdvisor: '',
        orderAdvisorId: 0,
        orderAdvisorMail: '',
        orderAnnotations: '',
        orderCopies: 0,
        orderCopyTo: '',
        orderDeliveryDate: currentDate,
        deliveryAdress: 0,
        deliveryAdressRoom: '',
        orderPrePrint: false,
        orderReceiver: '',
        orderReceiverId: 0,
        orderReceiverMail: '',

        //imageUpload
        imageType: 1,
        low: 0,
        medium: 0,
        thumb: 0,
        imageName: '',
        imageCategory: 0,
        imageTitle: '',
        mediumKb: 0,
        lowKb: 0,
        thumbKb: 0,
        svgRot: 0,
        svgGrau: 0,
        png: 0,
        jpg: 0,
        proofThumb: false,
        imageWidth: 0,
        imageHeight: 0,

        //common values
        id: 0,
        modelType: '',
        tableData: {},
    };
    return model;
}

export function schema() {
    var schema = {
        fields: [
            // DOCUMENT
                {
                    type: 'breakLine',
                    visible() {
                        if (this && this.vueModel) {
                            if ((this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc')) return true; else return false;
                        }
                        return false;
                    }
                },
                //Headline Files
                {
                    type: 'headLine',
                    class: 'formHeadline',
                    text: 'Datei-Verarbeitung',
                    size: 'h5',
                    visible() {
                        if (this && this.vueModel) {
                            if ((this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc')) return true; else return false;
                        }
                        return false;
                    }
                },
                //current Datei
                    {
                        type: 'currentFiles',
                        model: 'fileCurrent',
                        label: 'Aktuelle Dateien',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },
                    //neue Datei
                    {
                        type: 'checkbox',
                        model: 'newFile',
                        values: [
                            {
                                id: true, name: 'Es gibt neue Dokumente'
                            }
                        ],
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },
                    // Datei Upload
                    {
                        type: 'fileUploadHint',
                        label: 'Dateien hochladen', 
                        model: 'files',
                        fileUpload: 'filesUpload',
                        validator: ['checkFileUpload'],
                        validatorText: '',
                        required: true,
                        findForProof: 'docType',
                        errorShow: false,
                        errorText: [],
                        typeChange: true,
                        fileHint: '<ul>'+
                                    '<li> Die Dateinamen '+
                                        '<u>müssen </u> '+
                                        'einem bestimmten Schema folgen: [Sparte]_[Netzgebiet]_[Dokumentennummer]_[Versionsnummer]_[Dateititel]_[Appendix].[Dateiformat].'+ 
                                        '<br>'+
                                        'Z.B.: Netze_HB-BHV_001_001_Dies-ist-eine-Testdatei_WEB.pdf'+
                                    '</li>'+
                                    '<li> Beachten Sie, dass '+
                                        '<u>keine</u> '+
                                        'Sonderzeichen, Umlaute, Leerzeichen oder Punkte im Dateinamen sind. Erlaubt sind nur Unterstriche (_) und Bindestriche (-).'+
                                    '</li>'+
                                    '<li>Der Dateiname außer dem Appendix '+
                                        '<u>muss</u> '+ 
                                        'für alle Dateien gleich sein.'+
                                    '</li>'+
                                    '<li> Es wird '+
                                        '<u>immer</u> '+
                                        'ein _WEB.pdf benötigt!'+
                                    '</li>'+
                                    '<li> Jeder Dateiname '+
                                        '<u>benötigt</u> '+
                                        'einen Appendix  '+
                                        '<br>'+
                                        'Beispiel: '+
                                        '<i>name-der-datei_WEB.pdf</i>'+
                                    '</li>'+
                                    '<li> Folgende Appendizes für PDF-Dateien sind erlaubt:'+
                                        '<ul>'+ 
                                            '<li>_WEB</li>'+
                                            '<li>_EDIT</li>'+
                                            '<li>_PRINT</li>'+
                                            '<li>_online_abschluss_EDIT</li>'+
                                        '</ul>'+
                                    '</li>'+
                                    '<li> Für Office-Dokumente werden folgende Appendizes benötigt:'+
                                        '<ul>'+
                                            '<li>Word-Dokumente: _DOCX</li>'+
                                            '<li>Excel-Dokumente: _XLSX</li>'+
                                            '<li>PowerPoint-Dokumente: _PPTX</li>'+
                                            '<li>Zip-Dateien bekommen den Appendix _ZIP</li>'+
                                        '</ul>'+
                                    '</li>'+
                                '</ul>'
                        ,
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.newFile === true && (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc')) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //grouped File data
                    { 
                        type: 'groupFunction',
                        label: 'Dokumentenparameter',
                        model: 'groupFunction',
                        elements: [ 
                            //docCategory disabled
                            {
                                type: 'select',
                                values: [],
                                model: 'docCategory',
                                label: 'Kategorie',
                                disabled: true,
                            },
                            //docNetLocation disabled
                            {
                                type: 'select',
                                values: [],
                                model: 'docNetLocation',
                                label: 'Netzgebiet',
                                disabled: true,
                            },
                            //docInventarNumber disabled
                            {
                                type: 'input',
                                inputType: 'text',
                                model: 'docInventarNumber',
                                label: 'Dokumentennummer',
                                disabled: true,
                            },
                            //docVersionNumber disabled
                            {
                                type: 'input',
                                inputType: 'text',
                                model: 'docVersionNumber',
                                label: 'Versionsnummer',
                                disabled: true,
                            }
                        ],
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },
                    //preVersion
                    {
                        type: 'switch',
                        label: 'Gibt es eine Vorversion',
                        model: 'docPreVersion',
                        idLabel: 'idPreVersion',
                        values: [
                            { id: 0, name: 'Nein' },
                            { id: 1, name: 'Ja' }
                        ],
                        textOff: 'Nein',
                        textOn: 'Ja',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' && this.vueModel.model.docVersionNumber > 1) return true; else return false;
                            }
                            return false;
                        },
                        disabled: false
                    },
                    //Single Datei Upload
                    {
                        type: 'fileUploadSingle',
                        label: 'Vorversion hochladen',
                        model: 'docPreVersionFile',
                        fileUpload: 'filesUploadPreVersion',
                        validator: ['checkFileUploadPreVersion'],
                        validatorText: '',
                        required: true,
                        errorShow: false,
                        errorText: '',
                        visible() {
                            if (this && this.vueModel) {
                                if ((this.vueModel.model.modelType === 'newDoc'  || this.vueModel.model.modelType === 'changeDoc') && this.vueModel.model.docPreVersion === true) return true; else return false;
                            }
                            return false;
                        }
                    },
  
                //ruler
                {
                    type: 'horizonticalLine',
                    class: 'formHr',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                        }
                        return false;
                    }
                },
                //Headline Dokument Angaben
                {
                    type: 'headLine',
                    class: 'formHeadline',
                    text: 'Dienstleister',
                    size: 'h5',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                        }
                        return false;
                    }
                },
                    //if ServiceProvider
                    {
                        type: 'switch',
                        label: 'Soll dieses Dokument für Dienstleister zur Verfügung gestellt werden?',
                        model: 'docServiceProvider',
                        idLabel: 'idDocServiceProvider',
                        values: [
                            { id: 0, name: 'Nein' },
                            { id: 1, name: 'Ja' }
                        ],
                        textOff: 'Nein',
                        textOn: 'Ja',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        },
                        disabled: false
                    },
                    //Mediatype

                    {
                        type: 'checklist',
                        label: 'Dienstleister',
                        model: 'docServiceProviderId',
                        required: true,
                        validator: ['checkArray'],
                        validatorText: 'den Dienstleister', 
                        errorShow: false,
                        errorText: '',
                        values: [],
                        inline: false,
                        overflow: true,
                        automaticSort: true,
                        visible() {
                            if (this && this.vueModel) {
                                if ((this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') && this.vueModel.model.docServiceProvider === true) return true; else return false;
                            }
                            return false;
                        },
                    },  
                //ruler
                {
                    type: 'horizonticalLine',
                    class: 'formHr',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                        }
                        return false;
                    }
                },
                //Headline Dokument Angaben
                {
                    type: 'headLine',
                    class: 'formHeadline',
                    text: 'Dokumentinhalt',
                    size: 'h5',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                        }
                        return false;
                    }
                },
                    //Mediatype
                    {
                        type: 'select',
                        label: 'Medienart',
                        model: 'docMediaType',
                        required: true,
                        validator: ['checkSelect'],
                        validatorText: 'die Medienart',
                        errorShow: false,
                        errorText: '',
                        values: [],
                        buttons: {
                            type: 'text',
                            text: 'neue Medienart',
                            class: 'buttonForm',
                            onclick: {
                                'functionVal': "produceParams",
                                'argumentsVal': ['mediaType', 'neue Medienart']
                            },
                            visible() {
                                if (this && this.vueModel) {
                                    if (parseInt(this.vueModel.model.userStatus) === 6) return true; else return false;
                                }
                                return false;
                            }
                        },
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },                
                    //Advisor
                    {
                        type: 'select',
                        label: 'Dokumentverantwortung',
                        model: 'docAdvisor',
                        required: true,
                        validator: ['checkSelect'],
                        validatorText: 'die Dokumentverantwortung',
                        errorShow: false,
                        errorText: '',
                        values: [],
                        buttons: {
                            type: 'text',
                            text: 'neue Dokumentverantwortung',
                            class: 'buttonForm',
                            onclick: {
                                'functionVal': "produceParams",
                                'argumentsVal': ['advisor', 'neue Dokumentverantwortung']
                            },
                            visible() {
                                if (this && this.vueModel) {
                                    if (parseInt(this.vueModel.model.userStatus) === 6) return true; else return false;
                                }
                                return false;
                            }
                        },
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Sparte
                    {
                        type: 'checklist',
                        label: 'Sparte',
                        model: 'docSection',
                        required: true,
                        validator: ['checkInput'],
                        validatorText: 'eine Sparte',
                        errorShow: false,
                        errorText: '',
                        values: [],
                        inline: true,
                        overflow: false,
                        automaticSort: false,
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Bereich            
                    {
                        type: 'select',
                        model: 'docArea',
                        label: 'Bereich',
                        values: [],
                        required: true,
                        validator: ['checkSelect'],
                        validatorText: 'den Bereich',
                        errorShow: false,
                        errorText: '',
                        buttons: {
                            type: 'text',
                            text: 'neuer Bereich',
                            class: 'buttonForm',
                            onclick: {
                                'functionVal': "produceParams",
                                'argumentsVal': ['docArea', 'neuer Bereich']
                            },
                            visible() {
                                if (this && this.vueModel) {
                                    if (parseInt(this.vueModel.model.userStatus) === 6) return true; else return false;
                                }
                                return false;
                            }
                        },
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },  
                    //Thema
                    {     
                        type: 'input',
                        inputType: 'text',
                        model: 'docTopic',
                        label: 'Thema',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }

                    },
                    //Verwendungszweck
                    {     
                        type: 'input',
                        inputType: 'text',
                        model: 'docPurpose',
                        label: 'Verwendungszweck',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }

                    },
                    //Anmerkung
                    {     
                        type: 'input',
                        inputType: 'text',
                        model: 'docNotations',
                        label: 'Anmerkung',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }

                    },
                    //Datum der Freigabe
                    {
                        type: 'datetimepicker',
                        label: 'Datum der Freigabe',
                        model: 'docDateRelease',
                        format: 'YYYY-MM-DD',
                        dateformat: 'date',
                        required: true,
                        errorShow: false,
                        errorText: '',
                        validator: ['checkDate'],
                        validatorText: 'das Datum der Freigabe',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Gültigkeit
                    {
                        type: 'datetimepicker',
                        label: 'gültig bis',
                        model: 'docDateValidity',
                        format: 'YYYY-MM-DD',
                        dateformat: 'date',
                        required: true,
                        errorShow: false,
                        errorText: '',
                        validator: ['checkDate'],
                        validatorText: 'das Gültigkeitsdatum',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },
                    // Agency
                    {
                        type: 'select',
                        label: 'Agentur',
                        model: 'docAgency',
                        values: [],
                        required: true,
                        validator: ['checkSelect'],
                        validatorText: 'die Agentur',
                        errorShow: false,
                        errorText: '',
                        buttons: {
                            type: 'text',
                            text: 'neue Agentur',
                            class: 'buttonForm',
                            visible() {
                                if (this && this.vueModel) {
                                    if (parseInt(this.vueModel.model.userStatus) === 6) return true; else return false;
                                }
                                return false;
                            },
                            onclick: {
                                'functionVal': "produceParams",
                                'argumentsVal': ['docAgency', 'neue Agentur']
                            },
                        },
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },
                //ruler
                {
                    type: 'horizonticalLine',
                    class: 'formHr',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                        }
                        return false;
                    }
                },
                //Headline Dokument Angaben
                {
                    type: 'headLine',
                    class: 'formHeadline',
                    text: 'Druckproduktion',
                    size: 'h5',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                        }
                        return false;
                    }
                },
                    //Print Typ
                    {
                        type: 'select',
                        label: 'Druckanweisung',
                        model: 'printType',
                        values: [],
                        required: true,
                        validator: ['checkPrintFile'],
                        validatorText: 'die Druckanweisung',
                        errorShow: false,
                        errorText: '',
                        hinted: 'Achtung! Für die Auswahl "Druckerei-PDF" muss ein PRINT.pdf mit hochgeladen werden. Für die Auswahl "Online/Selbstausdruck-PDF" wird das (ggfs. schon hochgeladene) PRINT.pdf automatisch gelöscht.',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Print Format
                    {
                        type: 'select',
                        values: [],
                        label: 'Dokumentformat',
                        model: 'printFormat',
                        required: true,
                        validator: ['checkSelect'],
                        validatorText: 'ein Dokumentformat',
                        errorShow: false,
                        errorText: '',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Print Color
                    {
                        type: 'select',
                        values: [],
                        label: 'Druckfarben',
                        model: 'printColor',
                        required: true,
                        validator: ['checkSelect'],
                        validatorText: 'die Druckfarbe',
                        errorShow: false,
                        errorText: '',
                        visible() {
                            if (this && this.vueModel) {
                                if ((this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') && this.vueModel.model.showPrintValues === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Print Seiten
                    {     
                        type: 'input',
                        inputType: 'text',
                        model: 'printPages',
                        label: 'Anzahl Druckseiten',
                        required: true,
                        validator: ['checkPrintPages'],
                        validatorText: 'die Anzahl der Druckseiten',
                        errorShow: false,
                        errorText: '',
                        visible() {
                            if (this && this.vueModel) {
                                if ((this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') && this.vueModel.model.showPrintValues === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Print PageType
                    {
                        type: 'select',
                        values: [],
                        label: 'Einseitig/beidseitig bedruckt?',
                        model: 'printPageType',
                        required: true,
                        validator: ['checkSelect'],
                        validatorText: 'einseitig oder beidseitig',
                        errorShow: false,
                        errorText: '',
                        visible() {
                            if (this && this.vueModel) {
                                if ((this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') && this.vueModel.model.showPrintValues === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Print Production
                    {
                        type: 'select',
                        values: [],
                        label: 'Druckproduktion',
                        model: 'printProduction',
                        required: true,
                        validator: ['checkSelect'],
                        validatorText : 'eine Druckproduktion',
                        errorShow: false,
                        errorText: '',
                        visible() {
                            if (this && this.vueModel) {
                                if ((this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') && this.vueModel.model.showPrintValues === 1) return true; else return false;
                            }
                            return false;
                        },
                        buttons: {
                            type: 'text',
                            text: 'neue Druckproduktion',
                            class: 'buttonForm',
                            visible() {
                                if (this && this.vueModel) {
                                    if (parseInt(this.vueModel.model.userStatus) === 6) return true; else return false;
                                }
                                return false;
                            },
                            onclick: {
                                'functionVal': "produceParams",
                                'argumentsVal': ['printProduction', 'neue Druckproduktion']
                            }
                        }
                    },
                    //explicit print values
                        {
                            type: 'freeTextModel',
                            model: 'printProductionExplicit',
                            class: 'printProductionValues',
                            visible() {
                                if (this && this.vueModel) {
                                    if ((this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') && this.vueModel.model.showPrintValues === 1 && this.vueModel.printProduction !== 0) return true; else return false;
                                }
                                return false;
                            }
                        },
                    //Print Kommentare
                    {     
                        type: 'input',
                        inputType: 'text',
                        model: 'printComment',
                        label: 'weitere Druckanweisungen',
                        visible() {
                            if (this && this.vueModel) {
                                if ((this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') && this.vueModel.model.showPrintValues === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Print Agency
                    {
                        type: 'select',
                        values: [],
                        label: 'Druckerei',
                        model: 'printAgency',
                        required: true,
                        validator: ['checkSelect'],
                        validatorText: 'die Druckerei',
                        errorShow: false,
                        errorText: '',
                        buttons: {
                            type: 'text',
                            text: 'neue Druckerei',
                            class: 'buttonForm',
                            onclick: {
                                'functionVal': "produceParams",
                                'argumentsVal': ['printAgency', 'neue Druckerei']
                            },
                            visible() {
                                if (this && this.vueModel) {
                                    if (parseInt(this.vueModel.model.userStatus) === 6) return true; else return false;
                                }
                                return false;
                            }
                        },
                        visible() {
                            if (this && this.vueModel) {
                                if ((this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') && this.vueModel.model.showPrintValues === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                //ruler
                {
                    type: 'horizonticalLine',
                    class: 'formHr',
                    visible() {
                        if (this && this.vueModel) {
                            if ((this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc')) return true; else return false;
                        }
                        return false;
                    }
                },
                //Headline Dokument Angaben
                {
                    type: 'headLine',
                    class: 'formHeadline',
                    text: 'Dokument speichern',
                    size: 'h5',
                    visible() {
                        if (this && this.vueModel) {
                            if ((this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc')) return true; else return false;
                        }
                        return false;
                    }
                },
                    //active inactive
                    {
                        type: 'switch',
                        label: 'Dokument ist aktiv oder inaktiv:',
                        model: 'docActive',
                        idLabel: 'docActive',
                        values: [
                            { id: 0, name: 'inaktiv' },
                            { id: 1, name: 'aktiv' }
                        ],
                        textOff: 'inaktiv',
                        textOn: 'aktiv',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },
                    //mail send?
                    {
                        type: 'switch',
                        label: 'Bestätigungs-E-Mail senden?',
                        model: 'emailSend',
                        idLabel: 'idEmailSend',
                        values: [
                            { id: 0, name: 'Nein' },
                            { id: 1, name: 'Ja' }
                        ],
                        textOff: 'Nein',
                        textOn: 'Ja',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Email Receiver
                    {
                        type: 'checklist',
                        label: 'E-Mail-Empfänger',
                        model: 'emailReceiver',
                        required: true,
                        validator: ['checkArray'],
                        validatorText: 'einen Empfänger', 
                        errorShow: false,
                        errorText: '',
                        values: [],
                        inline: false,
                        overflow: true,
                        automaticSort: true,
                        visible() {
                            if (this && this.vueModel) {
                                if ((this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') && this.vueModel.model.emailSend === true) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //weitere Empfänger
                    {
                        type: 'inputFEmail',
                        inputType: 'text', 
                        model: 'emailReceiverFurther',
                        hinted: '(Mehrere Empfänger bitte durch Kommata trennen)',
                        label: 'weitere E-Mail-Empfänger',
                        validator: ['checkEmailFurther'],
                        validatorText: 'einen Empfänger',
                        errorShow: false,
                        errorText: '',
                        checkIt: true,
                        visible() {
                            if (this && this.vueModel) {
                                if ((this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') && this.vueModel.model.emailSend === true) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //ruler
                    {
                        type: 'horizonticalLine',
                        class: 'formHr',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },
                //Headline Dokument Angaben
                {
                    type: 'headLine',
                    class: 'formHeadline',
                    text: 'Webservice wesernetz.de',
                    size: 'h5',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                        }
                        return false;
                    }
                },
                    //auf wesernetz.de
                    {
                        type: 'switch',
                        label: 'Wird dieses Dokument auf der Webseite von wesernetz.de zur Verfügung gestellt?',
                        model: 'wnWebsite',
                        idLabel: 'wnWebsite',
                        values: [
                            { id: 0, name: 'nein' },
                            { id: 1, name: 'ja' }
                        ],
                        textOff: 'nein',
                        textOn: 'ja',
                        hinted () {
                            if (this && this.vueModel) {
                                switch(this.vueModel.model.modelType) {
                                    case 'newDoc':
                                        if (this.vueModel.model.newFile === true && this.vueModel.model.files.length === 0) {
                                            return 'Sie müssen erst eine Datei auswählen, bevor Sie die Verbindung zu wesernetz.de setzen können.';
                                        }
                                        return '';
                                    case 'changeDoc':
                                        if (this.vueModel.model.newFile === false) {
                                            if (this.vueModel.model.wnWebsite === false) {
                                                return 'Sie müssen erst eine Datei auswählen, bevor Sie die Verbindung zu wesernetz.de setzen können.';
                                            } else {
                                                return '';
                                            }
                                        }
                                        return '';
                                }
                                return '';
                            }
                            return '';
                        },
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'newDoc' || this.vueModel.model.modelType === 'changeDoc') return true; else return false;
                            }
                            return false;
                        }
                    },
                    //auf wesernetz.de
                    {
                        type: 'switch',
                        label: 'Ist dieses Dokument auf wesernetz.de schon vorhanden?',
                        model: 'wnWebsiteUpdate',
                        idLabel: 'wnWebsiteUpdate',
                        values: [
                            { id: 0, name: 'nein' },
                            { id: 1, name: 'ja' }
                        ],
                        textOff: 'Nein',
                        textOn: 'Ja',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'changeDoc' && this.vueModel.model.wnWebsite === true) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //sitecore id eintragen
                    {     
                        type: 'input',
                        inputType: 'text',
                        model: 'wnWebsiteId',
                        label: 'Sitecore-ID',
                        required: true,
                        validator: ['checkInput'],
                        validatorText: 'die Sitecore-ID',
                        errorShow: false,
                        errorText: '',
                        hinted: 'Achtung! Wenn Sie diese ID ändern, achten Sie genau auf die richtige ID, damit es beim Upload zu wesernetz.de keine Probleme gibt!',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'changeDoc' && this.vueModel.model.wnWebsiteUpdate === true) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //welche Datei
                    {
                        type: 'swbWebSiteTitle',
                        label: 'Folgendes Dokument wird zur Verfügung gestellt:',
                        validator: ['checkWnUpdate'],
                        webSiteDoc: 'docFileName',
                        url: 'wesernetz.de',
                        required: true,
                        errorShow: false,
                        errorText: '',
                        visible() {
                            if (this && this.vueModel) {
                                if ((this.vueModel.model.modelType === 'changeDoc' || this.vueModel.model.modelType === 'newDoc') && this.vueModel.model.wnWebsite === true) return true; else return false;
                            }
                            return false;
                        }
                    },                    
            //new Param
                //advisor
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'paramName',
                    label: 'Name',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'einen Namen',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'advisor') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'paramMail',
                    label: 'E-Mail-Adresse',
                    validator: ['checkEmailExist'],
                    validatorText: 'eine E-Mail-Adresse',
                    checkMail: 'docAdvisor',
                    required: true,
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'advisor') return true; else return false;
                        }
                        return false;
                    }
                },
                //print Agency
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'paramName',
                    label: 'Firma',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'eine Firma',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printAgency') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'paramMail',
                    label: 'E-Mail-Adresse',
                    validator: ['checkEmailExist'],
                    validatorText: 'eine E-Mail-Adresse',
                    checkMail: 'printAgency',
                    required: true,
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printAgency') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'paramStreet',
                    label: 'Straße und Hausnummer',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'eine Straße',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printAgency') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'paramPlz',
                    label: 'Postleitzahl',
                    required: true,
                    validator: ['checkPLZ'],
                    validatorText: 'eine Postleitzahl',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printAgency') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'paramCity',
                    label: 'Ort',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'einen Ort',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printAgency') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'paramPhone',
                    label: 'Telefon',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'eine Telefonnummer',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printAgency') return true; else return false;
                        }
                        return false;
                    }
                },
                //doc Agency
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'paramName',
                    label: 'Firma',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'eine Firma',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'docAgency') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'paramMail',
                    label: 'E-Mail-Adresse',
                    validator: ['checkEmailExist'],
                    validatorText: 'eine E-Mail-Adresse',
                    checkMail: 'docAgency',
                    required: true,
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'docAgency') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'paramStreet',
                    label: 'Straße und Hausnummer',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'eine Straße',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'docAgency') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'paramPlz',
                    label: 'Postleitzahl',
                    required: true,
                    validator: ['checkPLZ'],
                    validatorText: 'eine Postleitzahl',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'docAgency') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'paramCity',
                    label: 'Ort',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'einen Ort',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'docAgency') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'paramPhone',
                    label: 'Telefon',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'eine Telefonnummer',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'docAgency') return true; else return false;
                        }
                        return false;
                    }
                },
                //docArea
                {
                    type: 'input',
                    inputType: 'text',
                    labe: 'Name',
                    model: 'paramName',
                    required: true,
                    validator: ['checkDocArea'],
                    validatorText: 'einen Bereich',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'docArea') return true; else return false;
                        }
                        return false;
                    }
                },
                //printMaterial
                {
                    type: 'input',
                    inputType: 'text',
                    label: 'Name',
                    model: 'paramName',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'das Druckmaterial',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printMaterial') return true; else return false;
                        }
                        return false;
                    }
                },
                //printProduction
                {
                    type: 'input',
                    inputType: 'text',
                    label: 'Titel des Mediums',
                    model: 'paramName',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'einen Namen',
                    errorShow: false,
                    errorText: '',
                    hinted: 'Mit Titel ist z.B. "Flyer" oder "Aufkleber" gemeint',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printProduction') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    label: 'Papier',
                    model: 'paramPaperType',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'das Papier',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printProduction') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    label: 'Papiergewicht',
                    model: 'paramWeightGeneral',
                    required: true,
                    validator: ['checkWeight'],
                    validatorText: 'ein Gewicht',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printProduction') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    label: 'Papiergewicht Umschlag bei Broschüren',
                    model: 'paramWeightCover',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printProduction') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    label: 'Papiergewicht Innenteil bei Broschüren',
                    model: 'paramWeightContent',
                    hinted: 'Ein Gewichtsangabe muss gemacht werden. Bei Broschüren bitte Umschlag und Innenteil, bei den anderen Medienarten reicht die Angabe im Feld Gewicht',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printProduction') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'switch',
                    label: 'Oder vergleichbares Papier?',
                    model: 'paramOtherPaper',
                    idLabel: 'paramOtherPaper',
                    values: [
                        { id: 0, name: 0 },
                        { id: 1, name: 1 }
                    ],
                    textOff: 'nein',
                    textOn: 'ja',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printProduction') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    label: 'weitere Druckanweisungen',
                    model: 'paramPaperProduction',
                    hinted: 'Hier würde z.B. bei Terminkarten "Block à Karten" stehen',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printProduction') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    label: 'weitere Druckanweisungen',
                    model: 'paramComments',
                    hinted: 'Hier würde z.B. bei Terminkarten "links geleimt" stehen',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printProduction') return true; else return false;
                        }
                        return false;
                    }
                },
                {
                    type: 'input',
                    inputType: 'text',
                    label: 'weitere Druckanweisungen',
                    model: 'paramComments2',
                    hinted: 'Hier würde z.B. bei Aufkleber "Ablösbarkeit nach Absprache" stehen',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'printProduction') return true; else return false;
                        }
                        return false;
                    }
                },
                //mediaType
                {
                    type: 'input',
                    inputType: 'text',
                    labe: 'Name',
                    model: 'paramName',
                    required: true,
                    validator: ['checkMedienart'],
                    validatorText: 'die Medienart',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'newParam' && this.vueModel.model.paramType === 'mediaType') return true; else return false;
                        }
                        return false;
                    }
                },
            // SEND FILE 
                //absender 
                {
                    type: 'select',
                    values: [],
                    label: 'Absender',
                    model: 'sender',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'einen Absender',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'sendFile') return true; else return false;
                        }
                        return false;
                    }
                },
                //absender name
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'senderName',
                    label: 'Absendername, der in der E-Mail angezeigt wird',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'einen Namen',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'sendFile') return true; else return false;
                        }
                        return false;
                    }
                },  
                //email empfänger
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'receiver',
                    label: 'E-Mail-Adresse des Empfängers',
                    required: true,
                    validator: ['checkEmail'],
                    validatorText: 'eine E-Mail-Adresse',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'sendFile') return true; else return false;
                        }
                        return false;
                    }
                },  
                //absender name
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'mailSubject',
                    label: 'Subject für die E-Mail',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'ein Subject',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'sendFile') return true; else return false;
                        }
                        return false;
                    }
                },  
                // textnachricht
                {
                    type: 'textarea',
                    model: 'textMessage',
                    label: 'Ihre Nachricht',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'eine Nachricht',
                    row: 7,
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'sendFile') return true; else return false;
                        }
                        return false;
                    }
                },
                //signatureSelect 
                {
                    type: 'select',
                    values: [],
                    label: 'E-Mail-Signatur von',
                    model: 'signatureSelect',
                    required: true,
                    validator: ['checkSignature'],
                    validatorText: 'eine Signatur',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'sendFile') return true; else return false;
                        }
                        return false;
                    },
                    buttons: {
                        type: 'text',
                        text: 'eigene Signatur anlegen',
                        class: 'buttonForm',

                        onclick: {
                            'functionVal': "openSignature",
                            'argumentsVal': []
                        },
                        visible() {
                            if (this && this.vueModel) {
                                if ((this.vueModel.model.modelType === 'sendFile') && (!sessionStorage.getItem('wnPortal_signature'))) return true;
                            }
                        }
                    },

                },
                // signature preview
                {
                    type: 'textarea',
                    model: 'signatureText',
                    label: 'Signatur Text',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'eine Signatur',
                    errorShow: false,
                    errorText: '',
                    row: 7,
                    disabled() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.signatureSelect === 'other') return false; 
                            return true;
                        }
                        return true;
                    },
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'sendFile' && this.vueModel.model.signatureSelect !== 0) return true; else return false;
                        }
                        return false;
                    }
                },
                //fileType
                {
                    type: 'checklist',
                    label: 'Bitte mindestens eine Datei auswählen',
                    model: 'fileType',
                    required: true,
                    validator: ['checkArray'],
                    validatorText: 'eine Datei',
                    errorShow: false,
                    errorText: '',
                    values: [],
                    inline: false,
                    overflow: true,
                    automaticSort: true,
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'sendFile') return true; else return false;
                        }
                        return false;
                    }
                },
                //count KB 
                {
                    type: 'input',
                    inputType: 'text',
                    label: 'Gesamtgröße der E-Mail',
                    model: 'countKB',
                    errorShow: false,
                    errorText: '',
                    checkIt: true,
                    validator: ['checkFileSize'],
                    disabled: true,
                    maxSize: 10,
                    hinted: 'Es dürfen nicht mehr als 10 MB insgesamt versendet werden',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'sendFile') return true; else return false;
                        }
                        return false;
                    },
                },
                // fileError
                {
                    type: 'freeTextModel',
                    model: 'fileError',
                    class: 'fileError',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'sendFile') return true; else return false;
                        }
                        return false;
                    },
                },
            // change user data
                //user name
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'name',
                    label: 'Name',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'einen Namen',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'changeUser') return true; else return false;
                        }
                        return false;
                    }
                },  
                //user mail
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'email',
                    label: 'E-Mail-Adresse',
                    required: true,
                    validator: ['checkEmail'],
                    validatorText: 'eine E-Mail-Adresse',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'changeUser') return true; else return false;
                        }
                        return false;
                    }
                }, 
                //user company
                {
                    type: 'input',
                    inputType: 'text',
                    model: 'company',
                    label: 'Firma',
                    required: true,
                    validator: ['checkInput'],
                    validatorText: 'eine Firma',
                    errorShow: false,
                    errorText: '',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'changeUser') return true; else return false;
                        }
                        return false;
                    }
                }, 
                // signatur
                {
                    type: 'textarea',
                    model: 'signature',
                    label: 'E-Mail Signatur',
                    row: 10,
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'changeUser') return true; else return false;
                        }
                        return false;
                    }
                },
            // select request
                {
                    type: 'radio',
                    model: 'requestSelect',
                    values : [
                        {id: 0, name: 'Ich möchte eine <b>Korrektur</b> beauftragen'},
                        {id: 1, name: 'Ich möchte eine <b>Druckanfrage</b> stellen'} 
                    ],
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'requestIt') return true; else return false;
                        }
                        return false;
                    }

                },
                //ruler
                {
                    type: 'horizonticalLine',
                    class: 'formHr',
                    visible() {
                        if (this && this.vueModel) {
                            if (this.vueModel.model.modelType === 'requestIt') return true; else return false;
                        }
                        return false;
                    }
                },
                // Korrektur
                    {
                        type: 'freeTextModelLabel',
                        label: 'Verantwortung',
                        model: 'requestAdvisorName',
                        class: 'requestAdvisor',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 0) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //weitere Empfänger
                    {
                        type: 'inputFEmail',
                        inputType: 'text', 
                        model: 'requestMailreceiver',
                        hinted: '(Mehrere Empfänger bitte durch Kommata trennen)',
                        label: 'Kopie (Verteilerkreis) an',
                        validator: ['checkEmailFurther'],
                        validatorText: 'einen Empfänger',
                        errorShow: false,
                        errorText: '',
                        checkIt: true,
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 0) return true; else return false;
                            }
                            return false;
                        }
                    },
                    // textnachricht
                    {
                        type: 'textarea',
                        model: 'requestMessage',
                        label: 'Nachricht an die Typonauten - geben Sie hier Ihre Korretkurwünsche an',
                        required: true,
                        validator: ['checkInput'],
                        validatorText: 'eine Nachricht',
                        row: 7,
                        errorShow: false,
                        errorText: '',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 0) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Datei Upload
                    {
                        type: 'fileUploadSingle',
                        label: 'Zusätzlich können Sie hier ein Dokument mit Korrekturanweisungen hochladen',
                        model: 'requestFile',
                        fileUpload: 'requestFileUpload',
                        validator: ['checkRequestFile'],
                        validatorText: 'eine Datei',
                        hinted: 'Folgende Dateitypen können Sie Versenden: PDF, docx (Word), pptx (PowerPoint). Bitte beachten Sie, dass die Dategröße nicht mehr als 20 MB beträgt.',
                        errorShow: false,
                        errorText: '',
                        maxSize: 20,
                        checkIt: true,
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 0) return true; else return false;
                            }
                            return false;
                        }
                    },
                //Order
                    //keine print-Datei
                    {
                        type: 'freeText',
                        freeText: 'Achtung! Für dieses Dokument ist eine Bestellung über das Medienportal nicht möglich. Bitte wenden Sie sich an <a href="mailto:wesernetz@typonauten.de">wesernetz@typonauten.de</a> zur individuellen Abstimmung.',
                        class: 'requestAdvisor2',
                        visible() {
                            if (this && this.vueModel) {
                                if (parseInt(this.vueModel.model.print) === 0 && this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Angebotsempfänger
                    {
                        type: 'freeTextModelLabel',
                        label: 'Angebotsempfänger:',
                        model: 'orderReceiver',
                        class: 'requestAdvisor',
                        visible() {
                            if (this && this.vueModel) {
                                if (parseInt(this.vueModel.model.print) === 1 && this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Dokumentverantwortlicher
                    {
                        type: 'freeTextModelLabel',
                        label: 'Dokumentverantwortlicher:',
                        model: 'orderAdvisor',
                        class: 'requestAdvisor',
                        visible() {
                            if (this && this.vueModel) {
                                if (parseInt(this.vueModel.model.print) === 1 && this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Kopie an
                    {
                        type: 'inputFEmail',
                        inputType: 'text', 
                        model: 'orderCopyTo',
                        hinted: 'Tragen Sie hier bitte die E-Mail-Adressen ein, die ebenfalls von der Druckerei ein Angebot erhalten sollen und nicht der Angebotsempfänger oder der Dokumentverantwortliche (sofern verschieden) sind. Mehre Empfänger bitte durch Kommata trennen. ',
                        label: 'Angebotskopie an',
                        validator: ['checkEmailOrder'],
                        validatorText: 'einen E-Mail-Adresse',
                        errorShow: false,
                        errorText: '',
                        checkIt: true,
                        visible() {
                            if (this && this.vueModel) {
                                if (parseInt(this.vueModel.model.print) === 1 && this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Kostenstelle
                    {
                        type: 'input',
                        inputType: 'text',
                        model: 'orderCostCenter',
                        label: 'Kostenstelle',
                        required: true,
                        validator: ['checkInput'],
                        validatorText: 'eine Kostenstelle',
                        errorShow: false,
                        errorText: '',
                        visible() {
                            if (this && this.vueModel) {
                                if (parseInt(this.vueModel.model.print) === 1 && this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //copies
                    {
                        type: 'input',
                        inputType: 'text',
                        model: 'orderCopies',
                        label: 'Auflage (Stückzahl)',
                        required: true,
                        validator: ['checkInput'],
                        validatorText: 'eine Auflage (Stückzahl)',
                        errorShow: false,
                        errorText: '',
                        visible() {
                            if (this && this.vueModel) {
                                if (parseInt(this.vueModel.model.print) === 1 && this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //LieferDatum
                    {
                        type: 'datetimepicker',
                        label: 'Lieferdatum:',
                        model: 'orderDeliveryDate',
                        format: 'YYYY-MM-DD',
                        dateformat: 'date',
                        required: true,
                        errorShow: false,
                        errorText: '',
                        validator: ['checkDate'],
                        validatorText: 'das Lieferdatum',
                        visible() {
                            if (this && this.vueModel) {
                                if (parseInt(this.vueModel.model.print) === 1 && this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //Auslieferung an 
                    {
                        type: 'select',
                        label: 'Auslieferung an',
                        model: 'deliveryAdress',
                        required: true,
                        validator: ['checkSelect'],
                        validatorText: 'eine Auslieferungsadresse',
                        errorShow: false,
                        errorText: '',
                        values: [
                        ],
                        visible() {
                            if (this && this.vueModel) {
                                if (parseInt(this.vueModel.model.print) === 1 && this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 1) return true; else return false;
                            }
                            return false;
                        }

                    },
                    // (mit Gebäude- und Raumnummer):
                    {
                        type: 'input',
                        inputType: 'text',
                        model: 'deliveryAdressRoom',
                        label: 'Gebäude- und Raumnummer',
                        validatorText: 'eine Gebäude- und Raumnummer',
                        required: true,
                        validator: ['checkInput'],
                        errorShow: false,
                        errorText: '',
                        visible() {
                            if (this && this.vueModel) {
                                if (parseInt(this.vueModel.model.print) === 1 && this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //papier
                    {
                        type: 'freeText',
                        freeText: 'Papier gem. der Konzernvorgaben!',
                        visible() {
                            if (this && this.vueModel) {
                                if (parseInt(this.vueModel.model.print) === 1 && this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                    //vorabdruck 
                    {
                        type: 'checkbox',
                        model: 'orderPrePrint',
                        values: [
                            {
                                id: true, name: 'Ich bitte um einen Vorabdruck vor Auflagendruck'
                            }
                        ],
                        visible() {
                            if (this && this.vueModel) {
                                if (parseInt(this.vueModel.model.print) === 1 && this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
                    // Anmerkungen
                    {
                        type: 'textarea',
                        model: 'orderAnnotations',
                        label: 'Sonstige Anmerkungen',
                        row: 5,
                        visible() {
                            if (this && this.vueModel) {
                                if (parseInt(this.vueModel.model.print) === 1 && this.vueModel.model.modelType === 'requestIt' && this.vueModel.model.requestSelect === 1) return true; else return false;
                            }
                            return false;
                        }
                    },
            //pix Upload
                    {
                        type: 'currentFiles',
                        model: 'fileCurrent',
                        label: 'Aktuelle Dateien',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'changeImage') return true; else return false; 
                            }
                            return false;
                        }
                    },
                    //neue Datei
                    {
                        type: 'checkbox',
                        model: 'newFile',
                        values: [
                            {
                                id: true, name: 'Es gibt neue Bilder'
                            }
                        ],
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.modelType === 'changeImage') return true; else return false; 
                            }
                            return false;
                        }
                    },
                    //Bild-Art
                    {
                        type: 'select',
                        label: 'Bilder-Art',
                        model: 'imageType',
                        required: true,
                        validator: ['checkSelect'],
                        validatorText: 'eine Bilder-Art',
                        errorShow: false,
                        errorText: '',
                        values: [{
                            id: 0, name: 'Bitte auswählen'
                        }],
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.imageType !== 0) {
                                    if (this.vueModel.model.modelType === 'newImage') { 
                                        return true;
                                    } else {
                                        if(this.vueModel.model.modelType === 'changeImage' && this.vueModel.model.newFile === true) return true; else return false;
                                    }
                                } else {
                                    return false;
                                }
                            }
                            return false;
                        }
                    },                    
                    //Datei Upload
                    {
                        type: 'fileUploadHint',
                        label: 'Dateien hochladen',
                        model: 'files', 
                        fileUpload: 'filesUpload', 
                        validator: ['checkFileUploadPix'],
                        validatorText: '',
                        required: true,
                        errorShow: false,
                        findForProof: 'imageType',
                        errorText: [],
                        fileHint: '<ul>'+
                                    '<li>Die Dateinamen  '+
                                        '<u>müssen</u> '+
                                        'einem bestimmten Schema folgen: wn_pb_[Titel des Bildes mit Bindestrichen getrennt]_[Dateiart(MEDIUM usw.)].[Dateiformat]. '+ 
                                        '<br>'+
                                        'Z.B.: wn_pb_strom_kabel-01_LOW.jpg'+
                                    '</li>'+
                                    '<li>Beachten Sie, dass '+
                                        '<u>keine</u> '+
                                        'Sonderzeichen, Umlaute, Leerzeichen oder Punkte im Dateinamen sind. Erlaubt sind nur Unterstriche (_) und Bindestriche (-).'+
                                    '</li>'+
                                    '<li>Der Dateiname außer dem Appendix '+
                                        '<u>muss</u> '+
                                        'für alle Dateien gleich sein.'+
                                    '</li>'+
                                    '<li>Es wird '+
                                        '<u>immer</u> '+
                                        ' ein _THUMB.jpg benötigt!'+
                                    '</li>'+
                                    '<li>Jeder Dateiname '+
                                        '<u>benötigt</u> '+
                                        'einen Appendix  '+
                                        '<br>'+
                                        'Beispiel: '+
                                        '<i>name-der-datei_MEDIUM.jpg</i>'+
                                    '</li>'+
                                    '<li>Zwingend Appendizes im Foto- und Grafiken-Bereich: '+
                                        '<ul>'+ 
                                            '<li>_MEDIUM</li>'+ 
                                            '<li>_LOW</li>'+ 
                                            '<li>_THUMB</li>'+ 
                                        '</ul>'+
                                    '</li>'+
                                    '<li>Zwingend Appendizes im Icon-Bereich:'+
                                        '<ul>'+ 
                                            '<li>_SVGrot</li>'+ 
                                            '<li>_SVGgrau</li>'+ 
                                            '<li>_THUMB</li>'+ 
                                        '</ul>'+
                                    '</li>'+
                                    '<li>Zwingend Appendizes im Logo-Bereich:'+
                                        '<ul>'+ 
                                            '<li>_PNG</li>'+ 
                                            '<li>_JPG</li>'+ 
                                            '<li>_THUMB</li>'+
                                        '</ul>'+
                                    '</li>'+
                                '</ul>'
                        ,
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.imageType !== 0) {
                                    if (this.vueModel.model.modelType === 'newImage') { 
                                        return true;
                                    } else {
                                        if(this.vueModel.model.modelType === 'changeImage' && this.vueModel.model.newFile === true) return true; else return false;
                                    }
                                } else {
                                    return false;
                                }
                            }
                            return false;
                        }
                    },
                    //Bild-Titel
                    {     
                        type: 'input',
                        inputType: 'text',
                        model: 'imageTitle',
                        label: 'Bildtitel',
                        required: true,
                        validator: ['checkInput'],
                        validatorText: 'einen Titel',
                        errorShow: false,
                        errorText: '',
                        visible() {
                            if (this && this.vueModel) {
                                if (this.vueModel.model.imageType !== 0) {
                                    if (this.vueModel.model.modelType === 'newImage' || this.vueModel.model.modelType === 'changeImage') return true; else return false;
                                } 
                                return false;
                            }
                            return false;
                        }
                    },
        ]
    };
    return schema;
}
